import { tv } from 'tailwind-variants';

import type { ColorVariant } from 'src/types/common';

const tagStyles = tv({
  base: 'inline-flex gap-2 items-center text-sm text-surface-75 font-medium rounded-full border px-3 py-0.5 whitespace-nowrap',
  variants: {
    variant: {
      surface: 'border-surface-15',
      primary: 'border-primary-15',
      secondary: 'border-secondary-15',
      success: 'border-green-15',
      danger: 'border-red-15',
      warning: 'border-yellow-15',
      ai: 'border-ai-15',
    },
  },
  defaultVariants: {
    variant: 'surface',
  },
});

const ghostTagStyles = tv({
  extend: tagStyles,
  variants: {
    variant: {
      surface: 'bg-surface-ghost border-surface-ghost-15 text-surface-ghost-75',
      primary: 'bg-primary-ghost border-primary-ghost-15 text-primary-ghost-75',
      secondary:
        'bg-secondary-ghost border-secondary-ghost-15 text-secondary-ghost-75',
      success: 'bg-green-ghost border-green-ghost-15 text-green-ghost-75',
      danger: 'bg-red-ghost border-red-ghost-15 text-red-ghost-75',
      warning: 'bg-yellow-ghost border-yellow-ghost-15 text-yellow-ghost-75',
      ai: 'bg-ai-ghost border-ai-ghost-15 text-ai-ghost-75',
    },
  },
});

export interface TagProps {
  title?: string;
  variant?: ColorVariant;
  ghost?: boolean;
  className?: string;
}

const Tag = ({
  className,
  variant = 'surface',
  ghost = false,
  title = '',
}: TagProps) => {
  return (
    <span
      className={
        ghost
          ? ghostTagStyles({ variant, className })
          : tagStyles({ variant, className })
      }
    >
      {title}
    </span>
  );
};

export default Tag;
